<template>
  <v-data-table
    :headers="headers"
    :items="model"
    :search="search"
    :server-items-length="length"
    :options.sync="optionsLocal"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    item-key="id"
    show-expand
  >
    <template v-slot:item.request_type="{ item }">
      <v-chip :color="getColor(item.request_type)" dark>{{ getLabel(item.request_type) }}</v-chip>
    </template>
    <template v-slot:item.point="{ item }">
      <!-- <kbd class="text-caption"> -->
      {{ getTextPoint(item.point) }}
      <!-- </kbd> -->
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-row v-if="item.request_type === wapiRequestType.ValidTimes">
          <v-col>
            Заблаговременности:
            <code>[{{ item.billing_radar.valid_times.join(', ') }}]</code>
          </v-col>
        </v-row>
        <v-row v-if="item.request_type === wapiRequestType.Preset">
          <v-col>
            <billing-preset :geoJson="item.billing_preset.geoJson" />
          </v-col>
        </v-row>
        <v-row v-if="item.request_type === wapiRequestType.Point">
          <v-col>            
            <billing-point v-if="coordinateOrder == lonLat" :markerLatLng="[item.point.x, item.point.y]" />
            <billing-point v-if="coordinateOrder == latLon" :markerLatLng="[item.point.y, item.point.x]" />
          </v-col>
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { WapiRequestType, WapiCoordinateOrder, LAT_LON, LON_LAT } from "../constants";
import { WapiDataType } from "../constants";
import BillingPoint from "./BillingPoint";
import BillingPreset from "./BillingPreset.vue";

export default {
  name: "BillingDetail",
  components: {
    BillingPoint,
    BillingPreset
  },
  props: {
    model: Array,
    length: {
      type: Number,
      default: 0
    },
    coordinateOrder:  {
      type: String,
      default: function() {
        return LAT_LON;
      }
    },
    dataType: Number,
    options: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      latLon: LAT_LON,
      lonLat: LON_LAT,
      optionsLocal: this.options,
      wapiRequestType: WapiRequestType,
      wapiDataType: WapiDataType,
      wapiCoordinateOrder: WapiCoordinateOrder,
      expanded: [],
      singleExpand: false,
      search: "",
      defaultHeaders: [
        { text: "Идентификатор пользователя", value: "user_id" },
        { text: "Тип", value: "request_type" },
        { text: "Идентификатор территории", value: "billing_preset.preset_id" },
        { text: "Точка", value: "point" },
        { text: "Название территории", value: "billing_preset.name" },
        { text: "Площадь территории", value: "billing_preset.area_calculated" },
        { text: "Дата", value: "date" }
      ],
      radarHeaders: [
        { text: "Идентификатор пользователя", value: "user_id" },
        { text: "Территория", value: "billing_radar.territory" },
        { text: "Параметр", value: "billing_radar.parameter" },
        { text: "Базовое время", value: "billing_radar.base_time" },
        { text: "Дата", value: "date" }
      ]
    };
  },
  watch: {
    optionsLocal(val) {
      this.$emit("optionschange", val);
    },
    length() {
      this.options.page = 0;
    }
  },
  computed: {
    headers() {
      if (this.dataType === this.wapiDataType.Radar) {
        return this.radarHeaders;
      }

      return this.defaultHeaders;
    }
  },
  methods: {
    getTextPoint(point) {
      if (point) {
        return `[${point.x}, ${point.y}]`;
      }

      return "";
    },
    getColor(requestType) {
      if (requestType === this.wapiRequestType.Preset) return "primary";
      if (requestType === this.wapiRequestType.Point) return "success";
      return "grey";
    },
    getLabel(requestType) {
      if (requestType === this.wapiRequestType.Preset) return "Территория";
      if (requestType === this.wapiRequestType.Point) return "Точка";
      if (requestType === this.wapiRequestType.Radar) return "Радар";
      return "Неопределено";
    }
  }
};
</script>